// CacheKey c31dc862fce5ba366f964c3eebe5249f
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  mr: {
    date: {
      abbr_month_names: [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      month_names: [
        null,
        "जानेवारी",
        "फेब्रुवारी",
        "मार्च",
        "एप्रिल",
        "मे",
        "जून",
        "जुलै",
        "ऑगस्ट",
        "सप्टेंबर",
        "ऑक्टोबर",
        "नोव्हेंबर",
        "डिसेंबर"
      ],
      order: [
        "day",
        "month",
        "year"
      ],
      day_names: [
        "रविवार",
        "सोमवार",
        "मंगळवार",
        "बुधवार",
        "गुरुवार",
        "शुक्रवार",
        "शनिवार"
      ],
      formats: {
        default: "%d/%m/%Y",
        long: "%d %B %Y",
        short: "%d %b"
      }
    },
    time: {
      am: "AM",
      pm: "PM"
    },
    time_zones: {
      est: "पूर्वी वेळ",
      edt: "पूर्वी वेळ",
      cst: "मध्य वेळ",
      cdt: "मध्य वेळ",
      mst: "पर्वतीय वेळ",
      mdt: "पर्वतीय वेळ",
      pst: "प्रशांत वेळ",
      pdt: "प्रशांत वेळ",
      hst: "हवाई–अल्युशन वेळ",
      hdt: "हवाई–अल्युशन वेळ",
      akst: "अलास्का वेळ",
      akdt: "अलास्का वेळ"
    }
  }
}

